import { useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Pricing from "@/components/landing/Pricing";
import Footer from "@/components/landing/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Campaign = () => {
    const { slug } = useParams();
    const [search] = useSearchParams();
    const tracked = useRef(false);

    useEffect(() => {
        if (tracked.current) return;
        tracked.current = true;
        axios.post(`${API}/track`, {
            slug,
            utm_source: search.get("utm_source"),
            utm_medium: search.get("utm_medium"),
            utm_campaign: search.get("utm_campaign"),
        }).catch(() => {});
    }, [slug, search]);

    return (
        <div data-testid="campaign-page">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Pricing />
            </main>
            <Footer />
        </div>
    );
};

export default Campaign;
